import nameof from "../../common/helpers/nameof";
import { CsvColumn } from "../../common/components/DownloadCsv";
import { AttendeeWithFeedback } from "./types/types";

const getColumns: (questions: string[]) => CsvColumn<AttendeeWithFeedback>[] = (questions) => [{
  title: "Name",
  accessor: nameof<AttendeeWithFeedback>("name"),
}, {
  title: "Company",
  accessor: nameof<AttendeeWithFeedback>("company"),
}, {
  title: "FCA Number",
  accessor: nameof<AttendeeWithFeedback>("fcaNumber"),
}, {
  title: "Email",
  accessor: nameof<AttendeeWithFeedback>("email"),
}, {
  title: "Postcode",
  accessor: attendee => attendee.address?.postCode,
}, {
  title: "Content Score",
  accessor: attendee => attendee.scores?.content,
}, {
  title: "Presenter Score",
  accessor: attendee => attendee.scores?.presenter,
},
...questions.map((question, index) => ({
  title: question,
  accessor: attendee => {
    const response = attendee.responses ? attendee.responses[index] : void 0;
    if (typeof response === "boolean") {
      return response ? "Yes" : "No";
    }
  },
} as CsvColumn<AttendeeWithFeedback>)),
];

export default getColumns;
